import { map } from "lodash";
import React from "react";

import Grid from "@material-ui/core/Grid";

import images from "./images";

const ImagesList = () => {
  return (
    <Grid
      container
      alignItems="center"
      style={{ padding: "24px", backgroundColor: "white" }}
    >
      {map(images, (v, k) => (
        <Grid
          item
          key={k}
          style={{ width: "80px", height: "100px", marginBottom: "20px" }}
        >
          <Grid container direction="column">
            <Grid
              item
              className="flexCenter"
              style={{
                justifyContent: "center",
                width: "70px",
                height: "70px",
              }}
            >
              <img
                src={v}
                alt="img"
                style={{ maxWidth: "70px", maxHeight: "70px" }}
              />
            </Grid>
            <Grid item style={{ maxWidth: "60px", wordBreak: "break-all" }}>
              {k}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default ImagesList;
